'use strict'; // Wrap a function in a `setTimeout` call. This is used to guarantee async
// behavior, which can avoid unexpected errors.

module.exports = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments, 0),
        newFunc = function newFunc() {
      return fn.apply(null, args);
    };

    setTimeout(newFunc, 0);
  };
};